import '../App.css';
import React, {useState, useEffect} from 'react';


function AddNewLine(text, outputArray){
  var brTextSplit = text.split("<br>")
    for(var j=0; j<brTextSplit.length-1; j++){
      outputArray.push(brTextSplit[j])
      outputArray.push(<br></br>)
      outputArray.push(<br></br>)
    }
    outputArray.push(brTextSplit[brTextSplit.length-1])
}

/**
 * Component for the header at the top of the page.
 * @return {Component}
 */
function Notice({text,link,word}) {
  var textSplit = text.split("<here>");
  var output = [];
  for(var i=0; i<textSplit.length-1; i++){
    AddNewLine(textSplit[i],output);
    output.push(<a href={link[i]}>{word[i]}</a>)
  }
  AddNewLine(textSplit[textSplit.length-1],output);
  
  output = [
    <b>Please note: </b>,
    "The Usage-Based Licensing (UBL) feature in Deadline 10 is now available through Deadline Cloud UBL—see setup ",
    <a target="_blank" href="https://awsthinkbox.zendesk.com/hc/en-us/articles/22883209044759-AWS-Deadline-Cloud-UBL-for-Deadline-10-on-AWS">instructions</a>,
    " and the ",
    <a target="_blank" href="https://aws.amazon.com/deadline-cloud/">AWS Deadline Cloud page</a>,
    " for details. The Thinkbox UBL Marketplace will no longer function after September 30, 2025, though any UBL hours previously purchased there can still be used until that date. For questions about existing UBL purchases, please contact ",
    <a href="mailto:support@awsthinkbox.zendesk.com">support@awsthinkbox.zendesk.com</a>,
    "."
  ]

  return (
    <div className="notice-container">
        {output}
    </div>
  );
}


export default Notice;
